"use strict";

define('uikit/modules/menu',['require','exports','module','underscore','marionette','../collections/container','../collections/grid','../collections/tree','../elements/text','../elements/dropdown','../mixins/component.mixin','../channel','../templates','../extra/size','../extra/color'],function (require, exports, module) {
  var _ = require('underscore');
  var Mn = require('marionette');
  var ContainerView = require('../collections/container');
  var Grid = require('../collections/grid');
  var Tree = require('../collections/tree');
  var TextView = require('../elements/text');
  var Dropdown = require('../elements/dropdown');
  var ComponentMixin = require('../mixins/component.mixin');
  var channel = require('../channel');
  var Templates = require('../templates');
  var Size = require('../extra/size');
  var Color = require('../extra/color');
  var MenuItem = Mn.ItemView.extend(ComponentMixin).extend({
    template: Templates.UIKit['menu.item'],
    attributes: {
      tabindex: 0
    },
    className: 'item',
    allowTagChange: true,
    options: {
      view: null,
      text: '',
      link: null,
      target: null,
      icon: '',
      active: false,
      fitted: false,
      disabled: false,
      iconOnly: false,
      visible: true,
      subMenu: null,
      role: 'menuitem'
    },
    update: {
      fitted: false,
      target: false,
      active: false
    },
    events: {
      'click': 'handleClick',
      'keydown': function keydown(ev) {
        if (ev.keyCode == 13) {
          this.handleClick();
        }
      }
    },
    handleClick: function handleClick() {
      if (!this.getOption('disabled')) {
        this.triggerMethod('press', this, this.model);
      }
    },
    updateAttributes: function updateAttributes() {
      if (this.getBoolOption('role')) {
        this.updateElementAttributes({
          role: this.getOption('role')
        });
      }
      this.addClass('icon', !this.getBoolOption('text') && this.getBoolOption('icon')).addClass('disabled', this.getBoolOption('disabled')).addClass('active', this.getBoolOption('active')).addClass('fitted', this.getBoolOption('fitted'));
      var link = this.getOption('link');
      if (link && _.isString(link)) {
        this.$el.attr('href', link);
      } else {
        this.$el.removeAttr('href');
      }
      if (this.getBoolOption('target')) {
        this.$el.attr('target', this.getOption('target'));
      } else {
        this.$el.removeAttr('target');
      }
    },
    onRender: function onRender() {
      if (this.view) {
        if (!this.view._isRendered) {
          this.view.render();
        }
        this.$el.append(this.view.$el);
      }
    }
  });
  var MenuImageItem = MenuItem.extend({
    className: 'item image',
    options: _.extend({}, MenuItem.prototype.options, {
      image: '',
      width: null,
      height: null
    }),
    onRender: function onRender() {
      var src = this.image,
        self = this,
        image = new Image();
      $(image).load(function () {
        self.trigger('image:load');
      }).error(function () {
        self.trigger('image:error');
      });
      image.src = src;
      MenuItem.prototype.onRender.apply(this, arguments);
    },
    template: Templates.UIKit['menu.image.item']
  });
  var MenuHeaderIteam = MenuItem.extend({
    className: 'header item',
    options: {
      text: ''
    }
  });
  var Menu = ContainerView.extend({
    className: 'ui menu',
    template: Templates.UIKit['menu'],
    ui: {
      menuBar: '.menu-container',
      rightMenu: '.right.menu'
    },
    options: {
      attached: false,
      basic: false,
      text: false,
      dark: false,
      fixed: false,
      fluid: false,
      hero: false,
      iconOnly: false,
      inverted: false,
      labeled: false,
      page: false,
      pagination: false,
      position: '',
      pointing: false,
      secondary: false,
      size: '',
      simple: false,
      tabular: false,
      title: true,
      vertical: false,
      color: null,
      compact: false,
      visible: true,
      role: 'menubar'
    },
    sizeOptionValues: _.values(Size),
    colorOptionValues: _.values(Color),
    update: {
      vertical: false,
      tabular: false,
      pagination: false,
      basic: false,
      text: false,
      fixed: false,
      size: false,
      position: false,
      pointing: false,
      inverted: false,
      secondary: false,
      simple: false,
      fluid: false,
      color: false,
      hero: false,
      compact: false,
      role: true
    },
    internalViews: {
      'title': TextView
    },
    onFirstRender: function onFirstRender() {
      this.listenTo(this, 'change:iconOnly', function () {
        this.each(function (view) {
          view.iconOnly = this.iconOnly;
        });
      });
      this.each(function (view) {
        view.iconOnly = this.iconOnly;
      });
      this.listenTo(this, 'add', function (view) {
        view.iconOnly = this.iconOnly;
      });
    },
    updateAttributes: function updateAttributes() {
      this.addClass(this.getOption('attached'), _.isString(this.getOption('attached'))).addClass('attached', this.getBoolOption('attached')).addClass('dark', this.getBoolOption('dark')).addClass('vertical', this.getBoolOption('vertical')).addClass('tabular', this.getBoolOption('tabular')).addClass('pagination', this.getBoolOption('pagination')).addClass('text', this.getBoolOption('text')).addClass('basic', this.getBoolOption('basic')).addClass('fixed', this.getBoolOption('fixed')).addClass('simple', this.getBoolOption('simple')).addClass('secondary', this.getBoolOption('secondary')).addClass('pointing', this.getBoolOption('pointing')).addClass('inverted', this.getBoolOption('inverted')).addClass('labeled icon', this.getBoolOption('labeled') && !this.getBoolOption('iconOnly')).addClass('icon', this.getBoolOption('iconOnly')).addClass(this.getOption('position'), this.getBoolOption('position')).addClass(this.getOption('size'), this.getBoolOption('size')).addClass('hero', this.getBoolOption('hero')).addClass(this.getOption('color'), this.getBoolOption('color')).addClass('fluid ' + (_.isString(this.getOption('fluid')) ? String(this.getOption('fluid')) : Grid.getSizeClass(this._views.length)) + ' item', this.getBoolOption('fluid')).addClass('compact', this.getBoolOption('compact'));
    },
    appendView: function appendView(view, options) {
      if (options.rightAligned) {
        this.ui.rightMenu.append(view.$el);
      } else if (this.ui.menuBar.length > 0) {
        this.ui.menuBar.append(view.$el);
      } else {
        this.$el.append(view.$el);
      }
    },
    add: function add(view, options) {
      var addView = null;
      if (!_.isObject(options)) {
        options = {
          rightAligned: !!options
        };
      }
      if (view instanceof Dropdown) {
        view.$el.addClass('item');
        view.mode = '';
        addView = view;
      } else if (view instanceof Tree) {
        view.$el.addClass('item').attr('role', 'menuitem');
        addView = view;
      } else if (view instanceof MenuItem) {
        addView = view;
      } else {
        if (view instanceof Menu) {
          view.$el.removeClass('ui');
        }
        addView = new MenuItem(_.extend({
          view: view
        }, options));
      }
      this.listenTo(view, 'press', function () {
        var args = _.toArray(arguments);
        this.triggerMethod.apply(this, ['item:press'].concat(args));
      });
      return ContainerView.prototype.add.call(this, addView, options);
    }
  }, {
    collectionize: function collectionize(items) {
      items = _.clone(items);
      for (var i = 0, len = items.length, item; i < len; i++) {
        item = _.clone(items[i]);
        if (item.children) {
          item.children = this.collectionize(item.children);
        }
        items[i] = item;
      }
      return new Backbone.Collection(items);
    },
    createMenuItems: function createMenuItems(items) {
      var defaultBindings = {
        collection: 'children',
        text: 'text',
        link: 'link',
        target: 'target',
        icon: 'icon',
        iconRight: 'iconRight',
        inverted: 'inverted',
        pointing: 'pointing'
      };
      return _.map(items, function (item) {
        var view = null;
        if (item.children) {
          if (item.subMenu) {
            view = new Menu.Item();
            view.model = new Backbone.Model(item);
            view.subMenu = new Menu();
            view.subMenu.model = view.model;
            view.subMenu.bindings = {
              inverted: 'inverted',
              text: 'basic'
            };
            view.subMenu.addAll(Menu.createMenuItems(item.children));
            view.bindings = view.childBindings = _.omit(defaultBindings, 'collection');
            view.subMenu.bindings.text = 'inline';
          } else if (item.tree) {
            view = new Tree();
            view.model = new Backbone.Model(item);
            view.model.set('children', this.collectionize([item]));
            view.bindings = view.childBindings = _.clone(defaultBindings);
          } else {
            view = new Dropdown({
              mode: 'button'
            });
            view.activation = 'hover';
            view.model = new Backbone.Model(item);
            view.model.set('children', this.collectionize(item.children));
            view.bindings = view.childBindings = _.clone(defaultBindings);
          }
          view.options.iconTop = true;
          return view;
        }
        var bindings = {};
        bindings.text = 'text';
        bindings.link = 'link';
        bindings.target = 'target';
        bindings.icon = 'icon';
        if (item.image) {
          bindings.image = 'image';
          bindings.width = 'width';
          bindings.height = 'height';
          bindings.alt = 'alt';
          view = new MenuImageItem();
        } else if (item.header) {
          view = new MenuHeaderIteam();
        } else {
          view = new MenuItem();
        }
        view.bindings = bindings;
        view.model = new Backbone.Model(item);
        return view;
      }, this);
    }
  });
  Menu.Item = MenuItem;
  Menu.ImageItem = MenuImageItem;
  Menu.HeaderItem = MenuHeaderIteam;
  Menu.HUGE = 'huge';
  Menu.LARGE = 'large';
  Menu.SMALL = 'small';
  Menu.MINI = 'mini';
  Menu.TINY = 'tiny';
  channel.reply('menu', function () {
    return Menu;
  });
  module.exports = Menu;
});

